import React from 'react';
import PropTypes from 'prop-types';

import { Feedback } from '@ontruck/orc';

const FeedbackWrapper = ({ className, feedback, params, t }) => (
  <div className={className}>
    <Feedback size="wideS" skin="success">
      {t(feedback, params)}
    </Feedback>
  </div>
);

FeedbackWrapper.propTypes = {
  className: PropTypes.string.isRequired,
  feedback: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  params: PropTypes.any,
};

FeedbackWrapper.defaultProps = {
  params: {},
};

export default FeedbackWrapper;
